<template>
  <div class="maxh-2bar scroll-y">
    <v-toolbar class="card-bar">
      <v-toolbar-title>Polígonos</v-toolbar-title>

      <v-btn icon @click="$emit('reload')" class="ml-5">
        <v-icon>refresh</v-icon>
      </v-btn>

      <v-spacer />

      <v-text-field
        v-model="txtKeywords"
        label="Filtrar..."
        single-line
        hide-details
        class="pa-0"
      />

      <v-spacer />

      <v-switch v-model="showAll" label="Mostrar todos" hide-details />

      <v-spacer />

      <v-btn icon @click="expandAll">
        <v-icon>mdi-expand-all</v-icon>
      </v-btn>
      <v-btn icon @click="collapseAll">
        <v-icon>mdi-collapse-all</v-icon>
      </v-btn>
    </v-toolbar>

    <v-expansion-panels accordion multiple focusable v-model="openedIndexes">
      <v-expansion-panel v-for="(row, i) in rows" :key="i">
        <v-expansion-panel-header
          :color="row.delta > 0 ? 'amber lighten-2' : null"
        >
          <div class="h-row">
            <div class="oderon-col-2">{{ row.clientId }}</div>
            <div class="oderon-col-2">{{ row.vehicleCode }}</div>
            <div class="oderon-col-1">
              {{ row.mbB.contents.length }} Polygons
            </div>
            <div class="oderon-col-1">
              {{ row.mbA.contents.length }} Polygons
            </div>
            <div class="oderon-col-1">delta: {{ row.delta }}</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <PolygonCompare :value="row" :showAll="showAll" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import _ from 'lodash'
import { compareRows, missingOne } from './compare-utils.js'
// import { matchAnyLike } from 'oderon-commons/src/utils'

let isSamePolygon = (x, y) => {
  return x.name == y.name
}

function comparePolygons({ before, after, allVehicles }) {
  let result = []
  let allCids = _.uniq([
    ..._.map(before, x => x.clientId),
    ..._.map(after, x => x.clientId)
  ]).sort()

  for (let cid of allCids) {
    let mbB = before.find(x => x.clientId == cid) || { contents: [] }
    let mbA = after.find(x => x.clientId == cid) || { contents: [] }

    let vehicle = allVehicles.find(x => x.clientId == cid)

    let pairs = compareRows(mbB.contents, mbA.contents, isSamePolygon)

    result.push({
      clientId: cid,
      vehicleCode: vehicle && vehicle.code,
      mbB,
      mbA,
      pairs,
      delta: pairs.filter(missingOne).length
    })
  }

  return result
}

export default {
  components: {
    PolygonCompare: require('./PolygonCompare.vue').default
  },
  props: {
    // estrutura do value: {
    //   before: [
    //     {
    //       mailboxId,
    //       clientId,
    //       contents: [
    //         {id, name, value, points, tags},
    //         ...
    //       ]
    //     },
    //     ...
    //   ],
    //   after: [
    //     {
    //       clientId,
    //       contents: [...]
    //     }
    //   ]
    // }
    value: { required: true },
    allVehicles: { type: Array, required: true }
  },
  data() {
    return {
      txtKeywords: null,
      openedIndexes: [],
      showAll: false
    }
  },
  computed: {
    rows() {
      return comparePolygons({
        before: this.value.before,
        after: this.value.after,
        allVehicles: this.allVehicles
      })
    }
    // filteredRows() {
    //   return this.rows.filter(r => {
    //     return matchAnyLike(
    //       this.txtKeywords,
    //       r.clientId,
    //       r.vehicleCode,
    //       r.itemB,
    //       r.itemA
    //     )
    //   })
    // }
  },
  methods: {
    expandAll() {
      let arr = this.rows.map((x, i) => i)
      this.openedIndexes = arr
    },

    collapseAll() {
      this.openedIndexes = []
    }
  }
}
</script>

<style></style>
